import {
  MODEL_TYPE
} from './model_types'

export const CASHIER_ENTITY_TYPE = {
  ACCOUNT: 10,
  CUSTOMER: 20,
  BANK_ACCOUNT: 30,
  EMPLOYEE: 40,
  CASH_ACCOUNT: 50,
  COMPANY: 60
}

export const CASHIER_ENTITY_TYPE_TO_MODEL_TYPE = {
  [CASHIER_ENTITY_TYPE.ACCOUNT]: MODEL_TYPE.ACCOUNT,
  [CASHIER_ENTITY_TYPE.CUSTOMER]: MODEL_TYPE.ACCOUNT,
  [CASHIER_ENTITY_TYPE.BANK_ACCOUNT]: MODEL_TYPE.BANK_ACCOUNT,
  [CASHIER_ENTITY_TYPE.EMPLOYEE]: MODEL_TYPE.EMPLOYEE,
  [CASHIER_ENTITY_TYPE.CASH_ACCOUNT]: MODEL_TYPE.CASH_ACCOUNT,
  [CASHIER_ENTITY_TYPE.COMPANY]: MODEL_TYPE.COMPANY
}
